import ApiService from './ApiService';

export default class AuthApi extends ApiService {
    getUsers(payload) {
        return this.get('user', payload);
    }

    changeStatusUser(data) {
        const { id, payload } = data;
        return this.put(`change-status-user/${id}`, payload);
    }

    // U2 (2026-05-06): role 変更 endpoint (BUSINESS 付与 / 剥奪用)。
    // backend (api repo) の PUT /system/change-role-user/:id にマップ。
    changeRoleUser(data) {
        const { id, payload } = data;
        return this.put(`change-role-user/${id}`, payload);
    }

    // Pattern A (2026-05-15): 直接 BUSINESS user 作成 (= POST /system/business-users)。
    // ADMIN auth required (= backend で enforce)。
    // payload: { username, email, password }
    createBusinessUser(payload: { username: string, email: string, password: string }) {
        return this.post('business-users', payload);
    }
}
